<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { CURRENT_YEAR } from '@/composables/utils.ts';

const { t } = useI18n();
const appVersion = import.meta.env.VITE_APP_VERSION;
</script>

<template>
  <q-footer>
    <q-toolbar class="items-center">
      <span class="q-mr-sm text-weight-regular text-muted"
        >{{ `© 2023-${CURRENT_YEAR} Modulos AG. -` }}
        <a
          href="https://status.modulos.ai/"
          target="_blank"
          class="text-caption text-weight-semibold text-muted"
          >{{ t('Status') }}</a
        >
        {{ ` - ${t('Version')}: ${appVersion}` }}</span
      >
    </q-toolbar>
  </q-footer>
</template>

<style lang="scss" scoped>
.q-footer {
  background: transparent;
  .q-toolbar {
    justify-content: center;
    align-items: center;
    // Fixed height: the floating Scout panel reserves this band.
    min-height: $footer-height;
    span {
      font-size: 10px;
      line-height: 16px;
    }
    a {
      text-decoration: none;
    }
  }
}
</style>
